import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { TradingStyleProvider } from "@/contexts/TradingStyleContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import StockDetail from "@/pages/StockDetail";
import HistoryPage from "@/pages/History";
import AnalyticsPage from "@/pages/Analytics";
import ScannerPage from "@/pages/Scanner";
import WatchlistsPage from "@/pages/Watchlists";
import WhatNowPage from "@/pages/WhatNow";
import TradeMonitorPage from "@/pages/TradeMonitor";
import EngineLabPage from "@/pages/EngineLab";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="dark min-h-screen bg-[#080B11] text-slate-100">
      <BrowserRouter>
        <AuthProvider>
          <TradingStyleProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/stock/:ticker" element={<ProtectedRoute><StockDetail /></ProtectedRoute>} />
            <Route path="/scanner" element={<ProtectedRoute><ScannerPage /></ProtectedRoute>} />
            <Route path="/what-now" element={<ProtectedRoute><WhatNowPage /></ProtectedRoute>} />
            <Route path="/trades" element={<ProtectedRoute><TradeMonitorPage /></ProtectedRoute>} />
            <Route path="/engine-lab" element={<ProtectedRoute><EngineLabPage /></ProtectedRoute>} />
            <Route path="/watchlists" element={<ProtectedRoute><WatchlistsPage /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
          </TradingStyleProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
